import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import ReadOutlinedSvg from "@ant-design/icons-svg/es/asn/ReadOutlined";
import AntdIcon from "../components/AntdIcon";
var ReadOutlined = function ReadOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ReadOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  ReadOutlined.displayName = 'ReadOutlined';
}
export default /*#__PURE__*/React.forwardRef(ReadOutlined);